<template>
  <div class="contact-page">
    <ContactThankYouPage />
  </div>
</template>

<script>
import ContactThankYouPage from '../components/elements/pages/ContactThankYouPage.vue'
export default {
  name: 'Contact',
  metaInfo: {
    title: 'Contact Us Thanks'
  },
  components: {
    ContactThankYouPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
</style>
